/**
 * Created by Florin David on 04/01/2017.
 */
import log from 'lib/log'
import { setGenericError } from 'actions/app'

import {
  DB_ERROR,
  OFFLINE_ERROR,
  SCRIPT_ERROR,
  SERVICE_WORKER_ERROR,
} from 'constants/errors'
import GraphQLError, { isGraphQLError } from 'lib/graphql-error'
import translations from 'lib/translations'

/**
 * Handle error - send log message and display a generic error
 */
const handleError = (message: string, error: Error | GraphQLError): void => {
  log.error(message, {
    error: error && error.message,
    trace: error && error.stack,
  })
  // Skip service worker error - the web server may be temporary offline
  if (
    error?.message?.startsWith(SERVICE_WORKER_ERROR) ||
    error?.message?.startsWith(DB_ERROR) ||
    error?.message?.startsWith(OFFLINE_ERROR) ||
    error?.message?.startsWith(SCRIPT_ERROR)
  ) {
    return
  }
  // if is graphql code and is translated, use code for message
  if (isGraphQLError(error) && translations['en']?.messages[error.code]) {
    setGenericError({
      title: 'Error',
      messageId: error.code,
    })
  } else {
    setGenericError({
      title: 'Error',
      message: error.message || message,
    })
  }
}

/**
 * Listen to promise unhandled rejections
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
window.addEventListener('unhandledrejection', (e: any): void => {
  handleError('Unhandled Rejection', (e.detail && e.detail.reason) || e.reason)
})
/* eslint-enable @typescript-eslint/no-explicit-any */

/**
 * Listen to uncaught errors
 */
window.addEventListener('error', (e: ErrorEvent): void => {
  // suppress the ResizeObserver error
  if (e && e.message === 'ResizeObserver loop limit exceeded') {
    /* eslint-disable no-console */
    console.error(e, e.stopPropagation)
    /* eslint-enable no-console */
    return
  }
  handleError('Uncaught Error', (e && e.error) || e)
})
